export interface ListEmptyStateProps {
  title: string;
  description: string;
}

/** Empty-state card as used in the Learning Suite admin. */
const ListEmptyState = ({ title, description }: ListEmptyStateProps) => (
  <div className="bg-white rounded-2xl border border-[#E4E7EC] p-10 text-center">
    <p className="text-[16px] text-[#12282A] font-bold mb-1">{title}</p>
    <p className="text-[14px] text-[#888]">{description}</p>
  </div>
);

export default ListEmptyState;
